import { type TranslationIDs, useIntl } from '@capsicum/common';
import { Goat } from '@capsicum/common-web';
import styled from 'styled-components';

interface EmptyRewardsGoatProps {
	title?: TranslationIDs;
}

export const EmptyRewardsGoat = ({ title = 'rewards.tabs.disabled' }: EmptyRewardsGoatProps) => {
	const { $t } = useIntl();

	return (
		<S.GoatStyle image="ankward" testID="rewards-disabled-fallback">
			<S.TitleContainer>
				<S.Title>{$t(title)}</S.Title>
			</S.TitleContainer>
		</S.GoatStyle>
	);
};

namespace S {
	export const GoatStyle = styled(Goat)`
		width: 100%;
		padding: ${({ theme }) => `0 ${theme.spacings.small} 0 ${theme.spacings.small}`};
		display: flex;
		flex: 1;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	`;

	export const TitleContainer = styled.div`
		width: 100%;
	`;

	export const Title = styled.p`
		padding: ${({ theme }) => `0 ${theme.spacings.small} 0 ${theme.spacings.small}`};
		text-align: center;
		margin-block-end: 0;
		margin-block-start: 0;
		${({ theme }) => theme.fonts.text.text4};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;
}
